import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDownloadURLForSurveyRulesTemplateRPC } from "./getPresignedDownloadUrlForSurveyRulesTemplateRPC";

export class GetPresignedDownloadURLForSurveyRulesTemplateRPCClientImpl extends GetPresignedDownloadURLForSurveyRulesTemplateRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDownloadURLForSurveyRulesTemplateRPC.Request): Promise<LeoRPCResult<GetPresignedDownloadURLForSurveyRulesTemplateRPC.Response, GetPresignedDownloadURLForSurveyRulesTemplateRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-rules/GetPresignedDownloadURLForSurveyRulesTemplate",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDownloadURLForSurveyRulesTemplateRPC.ResponseDTO,
      GetPresignedDownloadURLForSurveyRulesTemplateRPC.Errors.ErrorsDTO,
      GetPresignedDownloadURLForSurveyRulesTemplateRPC.Response,
      GetPresignedDownloadURLForSurveyRulesTemplateRPC.Errors.Errors
    >(
      response,
      "survey-rules/GetPresignedDownloadURLForSurveyRulesTemplate",
      GetPresignedDownloadURLForSurveyRulesTemplateRPC.Response.fromDTO,
      GetPresignedDownloadURLForSurveyRulesTemplateRPC.Errors.fromDTO
    );
  }
}
